module.exports = __webpack_public_path__ + "static/img/fiber1.bee20859.png";